import { createContext, useEffect, useState } from 'react';
import { auth } from '../useFirebaseInit';

export const AuthContext = createContext();

export default function AuthContextProvider({ children }) {

  const [user, setUser] = useState({
    userName: "",
    userId: "",
    pfpUrl: "",
    email: "",
    isEmailVerified: ""
  })

  const [isLoggedIn, setIsLoggedIn] = useState(false)

  useEffect(() => {

    auth.onAuthStateChanged(function (user) {
      if (user) {
        setUser({
          userName: user.displayName,
          userId: user.uid,
          pfpUrl: user.photoURL,
          email: user.email,
          isEmailVerified: user.emailVerified
        })
      }
      else {
        setUser({
          userName: "",
          userId: undefined,
          pfpUrl: "",
          email: "",
          isEmailVerified: ""
        })
      }
    });



    setIsLoggedIn(user.userId!="-1" && user.userId!=undefined)
  }, [])

  return (
    <AuthContext.Provider value={{ userName: user.userName, userId: user.userId, pfpUrl: user.pfpUrl, email: user.email, isEmailVerified: user.isEmailVerified, isLoggedIn: isLoggedIn, setUser }}>
      {children}
    </AuthContext.Provider>
  )
}

//userName={user.userName} userId={user.userId} pfpUrl={user.pfpUrl} email={user.email} isEmailVerified={user.isEmailVerified}